import { RequiredUpload } from '@flatsy/types/Applications'
import { Files, UppyFile, FormatedUppyFiles } from '@flatsy/types/Files'
import { FilesStatus } from '@flatsy/types/Files'
import { StatusType } from '@flatsy/types/Status'

const getMinimumFile = (files: Files[], mainKind: RequiredUpload): number => {
  if (mainKind && files[0]) {
    const file = files[0]
    const kind = mainKind.required.find((single) => single.kind === file.kind)
    if (kind) {
      return kind.min
    }
  }
  return 1
}

const getMinimumFileFromUppy = (files: UppyFile[], mainKind: RequiredUpload): number => {
  if (mainKind && files[0]) {
    const file = files[0]
    const kind = mainKind.required.find((single) => single.kind === file.kind)
    if (kind) {
      return kind.min
    }
  }
  return 1
}

/**
 * @description return a main status for main files kind. We check the status of all file with the Main kind status to define the main status
 * @param files Files
 * @returns
 */
export const getMainKindStatus = ({
  files,
  requiredUpload,
  includeUppyFile,
}: {
  files: Files[]
  requiredUpload?: RequiredUpload
  includeUppyFile?: FormatedUppyFiles
}): StatusType => {
  const statusArray: StatusType[] = []
  const hasUppyFile: UppyFile[] = []

  if (requiredUpload) {
    /* -------------------------------------------------------------------------- */
    /*                      CHECK STATUS INSIDE UPLOADED FILE                     */
    /* -------------------------------------------------------------------------- */
    files.forEach((file) => {
      if (file.status === FilesStatus.EXPIRED) {
        statusArray.push(StatusType.ERROR)
      }
      if (file.status === FilesStatus.NON_COMPLIANT) {
        statusArray.push(StatusType.ERROR)
      }
      if (file.status === FilesStatus.UNREADABLE) {
        statusArray.push(StatusType.ERROR)
      }
      if (file.status === FilesStatus.VALIDATED) {
        statusArray.push(StatusType.SUCCESS)
      }
      if (file.status === FilesStatus.TO_REVIEW) {
        statusArray.push(StatusType.WAITING)
      }
    })

    /* -------------------------------------------------------------------------- */
    /*                        CHECK FILES INSIDE UPPY STATE                       */
    /* -------------------------------------------------------------------------- */
    if (includeUppyFile) {
      const keys = Object.keys(includeUppyFile)
      keys.forEach((key) => {
        const file = includeUppyFile[key]

        if (file && requiredUpload.required.find((kind) => kind.kind === file.kind)) {
          hasUppyFile.push(file)
          statusArray.push(StatusType.WAITING)
        }
      })
    }

    if ((!files || files.length === 0) && hasUppyFile.length === 0) {
      return StatusType.WARNING
    }

    /* -------------------------------------------------------------------------- */
    /*                           HAS ONE FILE WITH ERROR                          */
    /* -------------------------------------------------------------------------- */
    const hasError = statusArray.find((status) => status === StatusType.ERROR)
    if (hasError) {
      return StatusType.ERROR
    }

    /* -------------------------------------------------------------------------- */
    /*                           HAS ALL FILES IMPORTED                           */
    /* -------------------------------------------------------------------------- */
    const hasProgess = statusArray.filter((status) => status === StatusType.WAITING)
    const hasDone = statusArray.filter((status) => status === StatusType.SUCCESS)

    /* -------------------------- IF INCLUDE UPPY FILE -------------------------- */
    if (includeUppyFile) {
      /* ---- CHECK PROGRESS LENGTH IS > OR = TO MINIMUM FILE REQUIRED BY KIND ---- */
      if (
        hasProgess.length &&
        hasProgess.length + (hasDone.length || 0) >= getMinimumFile(files, requiredUpload) &&
        hasProgess.length + (hasDone.length || 0) >= getMinimumFileFromUppy(hasUppyFile, requiredUpload)
      ) {
        return StatusType.WAITING
      }
    } else if (
      hasProgess.length &&
      hasProgess.length + (hasDone.length || 0) >= getMinimumFile(files, requiredUpload)
    ) {
      /* ---- CHECK PROGRESS LENGTH IS > OR = TO MINIMUM FILE REQUIRED BY KIND ---- */
      return StatusType.WAITING
    }

    /* ---- CHECK IF ALL FILE REQUIRED HAVE THE SUCCESS STATUS ---- */
    if (hasDone.length && hasDone.length >= getMinimumFile(files, requiredUpload)) {
      return StatusType.SUCCESS
    }
  }
  return StatusType.WARNING
}

/**
 * @description return a main status for main files kind. We check the status of all file with the Main kind status to define the main status
 * @param files Files
 * @returns
 */
export const hasOneFileWithError = ({ files }: { files: Files[] }): boolean => {
  const find = files.find(
    (file) =>
      file.status === FilesStatus.EXPIRED ||
      file.status === FilesStatus.NON_COMPLIANT ||
      file.status === FilesStatus.UNREADABLE
  )
  return !!find
}
